enum Platform {
  Ios = 'ios',
  Android = 'android',
  OtherMobile = 'other-mobile',
  Desktop = 'desktop',
  Other = 'other',
}
enum Browser {
  MetamaskApp = 'metamask-app',
  DeFiWalletApp = 'defi-wallet-app',
  Other = 'other',
}

type WindowWithOpera = Window &
  typeof globalThis & {
    opera: any;
  };

export const getUserAgent = ():
  | {
      platform: Platform | null;
      browser: Browser;
    }
  | undefined => {
  if (typeof window === 'undefined') return undefined;
  const result: {
    platform: Platform;
    browser: Browser;
  } = {
    platform: Platform.Other,
    browser: Browser.Other,
  };
  const ua =
    navigator.userAgent ||
    navigator.vendor ||
    (window as WindowWithOpera).opera;

  if (/android/i.test(ua)) {
    result.platform = Platform.Android;
  }

  if (
    /iPhone|iPad|iPod/i.test(ua) ||
    // iPad on iOS 13 detection
    (/Mac/i.test(ua) && 'ontouchend' in document)
  ) {
    result.platform = Platform.Ios;
  }

  if (/BlackBerry|Opera Mini|IEMobile|WPDesktop/i.test(ua)) {
    result.platform = Platform.OtherMobile;
  }

  if (/DeFiWallet/i.test(ua)) {
    result.browser = Browser.DeFiWalletApp;
  }
  if (/MetaMaskMobile/i.test(ua)) {
    result.browser = Browser.MetamaskApp;
  }

  return result;
};

export const getIsMobile = () => {
  const { platform } = getUserAgent() || {};

  return (
    platform === Platform.Ios ||
    platform === Platform.Android ||
    platform === Platform.OtherMobile
  );
};

export const getIsDeFiWalletApp = () =>
  getUserAgent()?.browser === Browser.DeFiWalletApp;
export const getIsMetaMaskApp = () =>
  getUserAgent()?.browser === Browser.MetamaskApp;

export const getIsInAppBrowser = () => {
  const { browser } = getUserAgent() || {};

  return browser === Browser.DeFiWalletApp || browser === Browser.MetamaskApp;
};

export const getIsIos = () => {
  const { platform } = getUserAgent() || {};

  return platform === Platform.Ios;
};

export const getIsAndroid = () => {
  const { platform } = getUserAgent() || {};

  return platform === Platform.Android;
};
